<template>
  <v-dialog width="600px" v-model="dialog" class="product-chooser-dialog">
    <v-card>
      <v-card-title style="display:flex;flex-direction: column;">
        {{ $t("cart.whatDishesAre") }}
        <span
          style="display: block;font-weight: 600;font-size: 32px;letter-spacing: -0.25px;"
        >
          {{ shareLabel }}
        </span>
      </v-card-title>
      <v-card-text>
        <v-checkbox
          @change="onSelectAll"
          v-model="isAllSelected"
          :label="$t('common.everything')"
        ></v-checkbox>
        <v-divider />
        <div style="height: 250px; overflow-y:scroll;">
          <v-list>
            <v-list-item
              dense
              v-for="(item, index) in items"
              :key="`order_id_${index}`"
            >
              <v-list-item-content>
                <v-checkbox
                  class="pl-2"
                  @change="onSelect"
                  v-model="item.can_be_shared"
                  :label="`${item.name}`"
                ></v-checkbox>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
      </v-card-text>
      <v-card-actions class="d-flex justify-center">
        <button
          :class="`checkout-button`"
          :style="[
            { 'border-radius': buttonBorderRadiusTheme },
            { color: colorsGeneralPrimary },
            { borderColor: colorsGeneralPrimary }
          ]"
          @click="submitRequest"
        >
          <span>{{ $t("common.askFor") }}</span>
        </button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { every } from "lodash";
export default {
  name: "SharedItems",
  props: ["isAdmin"],
  data() {
    return {
      dialog: false,
      isAllSelected: false,
      items: []
    };
  },
  computed: {
    shareLabel() {
      return process.env.VUE_APP_SHOW_SHARE_LABEL === "true"
        ? this.$t("common.toShare") + "?"
        : this.$t("common.first") + "?";
    }
  },
  methods: {
    submitRequest() {
      let self = this;
      let cart = this.isAdmin
        ? this.$store.state.admincart
        : this.$store.state.cart;
      // eslint-disable-next-line no-unused-vars
      let checkEveryCanbeShared = every(this.items, { can_be_shared: false });
      if (checkEveryCanbeShared) {
        cart.map(cartItem => {
          let item = self.items.find(
            x => x.order.trim() === cartItem.order.trim()
          );
          if (item) {
            cartItem.canBeShared = true;
            return cartItem;
          }
          return cartItem;
        });
      } else {
        cart.map(cartItem => {
          let item = self.items.find(
            x => x.order.trim() === cartItem.order.trim()
          );
          if (item) {
            cartItem.canBeShared = item.can_be_shared;
            return cartItem;
          }
          return cartItem;
        });
      }
      this.$emit("submit");
    },
    onSelectAll(isAllSelected) {
      this.items.map(x => {
        x.can_be_shared = isAllSelected;
        return x;
      });
    },
    onSelect() {
      let _hasUnselectedItem = this.items.find(x => !x.can_be_shared || false);
      this.isAllSelected = !_hasUnselectedItem;
    },
    openDialog() {
      this.dialog = true;
      let cart = this.isAdmin
        ? this.$store.state.admincart
        : this.$store.state.cart;
      this.items = [...cart].filter(x => x.canBeShared || false);

      this.items.map(x => {
        x.can_be_shared = false;
        return x;
      });

      this.isAllSelected = false;
    }
  }
};
</script>

<style></style>
